<template>
  <ModalConfirmation
    hasBlur
    :showModal="true"
    title="Revoke Access"
  >
    <template v-slot:body>
      <ParagraphBody>
        To revoke this user's access from Password Manager, you have to remove them from
        the following group(s) <b>{{ groupNames }}</b>.
      </ParagraphBody>
      <ParagraphBody>
        This will sign out and deactivate the password manager from all user's devices
        and will erase all passwords stored in their password manager.
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <Button
        text="Ok"
        @click="handleConfirm"
      />
    </template>
  </ModalConfirmation>
</template>

<script>

import {
  Button,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {

  name: 'PasswordManagerUnenrollUserModal',

  components: {
    Button,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    groups: {
      type: Array,
      required: true,
    },
  },

  computed: {
    groupNames() {
      return this.groups.map(group => group.name).join(', ');
    },
  },

  methods: {
    async handleConfirm() {
      this.$emit('close');
    },
  },
};
</script>
